// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subText[data-v-a119490a] {\n  color: var(--colorTextDescription, rgba(0, 0, 0, 0.45));\n  margin-left: 4px;\n  font-family: Outfit;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n", ""]);
// Exports
module.exports = exports;
